import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import GrassBody from './GrassBody';
import GrassHeader from './GrassHeader';
import { getProfileActionLog } from './models';

const Grass = () => {
  const grassListPromise = getProfileActionLog();

  return (
    <Box
      className={twJoin(
        'flex w-full flex-col gap-4',
        'tablet:w-[calc(100%_-_298px)] desktop:w-[calc(100%_-_348px)]'
      )}
    >
      <GrassHeader grassListPromise={grassListPromise} />
      <GrassBody grassListPromise={grassListPromise} />
    </Box>
  );
};

export default Grass;
